/**
 * Get favicon URL for a given website URL
 * Uses Google's favicon service as a reliable source
 */
export default function getFaviconUrl(url: string): string | null {
  try {
    const urlObj = new URL(url);
    // Use Google's favicon service for reliable favicon fetching
    return `https://www.google.com/s2/favicons?domain=${urlObj.hostname}&sz=64`;
  } catch {
    return null;
  }
}
